// Actions
export const IVA_FETCH  = '[Iva] Fetch'

// Mutations
export const IVA_META   = '[Iva] meta'
export const IVA_OBTAIN = '[Iva] obtain'
export const IVA_CLEAR  = '[Iva] clear'
export const IVA_SET_LOADING = '[Iva] set loading'
